export enum SignalEventType {
  changeNotificationCount = 'changeNotificationCount',
  evaluationTaskUpdate = 'evaluationTaskUpdate',
  commentUpdate = 'commentUpdate',
  monitorTaskUpdate = 'monitorTaskUpdate',
  evaluationRequestUpdate = 'evaluationRequestUpdate',
  verificationRequestUpdate = 'verificationRequestUpdate',
  verificationTaskUpdate = 'verificationTaskUpdate',
  productEvaluationTaskUpdate = 'productEvaluationTaskUpdate',
  ticketUpdate = 'ticketUpdate',
  commentsticketUpdate = 'commentsticketUpdate',
  refreshTickets = 'refreshTickets',
  fraudMonitoringRequestUpdate = 'fraudMonitoringRequestUpdate',
  fraudTaskUpdated = 'fraudTaskUpdated',
  rightUpdate = 'rightUpdate',
  certificateRequestUpdate = 'certificateRequestUpdate',
  surveyTaskUpdated = 'surveyTaskUpdated',
  surveyRequestUpdate = 'surveyRequestUpdate',
  invoiceOcrUpdate = 'invoiceOcrUpdate',
  invoiceOcrListUpdate = 'invoiceOcrListUpdate',
  consultationSessionUpdated = 'consultationSessionUpdated',
  sessionEnded = 'sessionEnded',
  newChatMessage = 'newChatMessage',
  submitteAssignmentScore = 'submitteAssignmentScore',
  liveSessionIsLive = 'liveSessionIsLive',
  newCourseUpdate = 'newCourseUpdate',
  courseOffline = 'courseOffline',
  courseOnline = 'courseOnline',
  assignmentReminder = 'assignmentReminder',
  consumerRefreshToken = 'consumerRefreshToken',
  consumerAiConversationCreated = 'consumerAiConversationCreated'
}

export interface SignalEvent<TDataShape> {
  type: SignalEventType,
  data: TDataShape
}
